import React from 'react'
import { useNavigate } from 'react-router-dom'
import Oferta1 from '../../images/oferta1.png'
import Oferta2 from '../../images/oferta2.png'
import Oferta3 from '../../images/oferta3.png'
import Oferta4 from '../../images/oferta4.png'
import css from './OfertaFirst.module.css'

const OfertaFirst = () => {
	const navigate = useNavigate()

	const handleClick = () => {
		window.scrollTo({ top: 0, behavior: 'smooth' })
		navigate('/kontakt')
	}

	return (
		<section className={css.aboutSection}>
			<ul className={css.ofertaList}>
				<li>
					<div className={css.aboutTitleWrapper}>
						<h2 className={css.aboutTitle}>Pomoc psychologiczna</h2>
					</div>
					<div className={css.aboutContainer}>
						<p className={css.aboutText}>
							Profesjonalna pomoc psychologiczna jest skierowana do osób
							doświadczających kryzysu życiowego, trudności osobistych lub
							problemów związanych z adaptacją do nowych okoliczności. Wspieram
							klientów w pierwszym kroku, pomagając w określeniu problemu,
							analizie jego przyczyn oraz wskazaniu czynników wpływających na
							pojawienie się trudnej sytuacji.
							<br />
							<br />
							Następnie proponuję odpowiednią formę wsparcia, która będzie
							najlepiej dopasowana do indywidualnych potrzeb i oczekiwań. W moim
							gabinecie oferuję pomoc w postaci krótkoterminowego wsparcia
							psychologicznego, poradnictwa oraz długoterminowej psychoterapii
							indywidualnej. Celem tych form wsparcia jest przywrócenie
							równowagi psychicznej, spokoju wewnętrznego oraz wzbogacenie
							zasobów emocjonalnych i osobistych.
						</p>
						<div className={css.textImgContainer}>
							<p className={css.aboutText}>
								Dla osób, które z różnych powodów nie mogą dotrzeć osobiście do
								gabinetu, oferuję również wizyty domowe. Ta forma wsparcia jest
								dedykowana zwłaszcza rodzicom małych dzieci, osobom starszym lub
								osobom, które ze względu na stan zdrowia nie mogą samodzielnie
								dotrzeć do miejsca terapii. <br />
								<br />
								Wizyty domowe mają dodatkową zaletę – pacjent może pozostać w
								komfortowych warunkach swojego domu, co sprzyja budowaniu
								relacji terapeutycznej oraz ułatwia efektywne prowadzenie
								konsultacji i psychoterapii.
							</p>
							<img className={css.aboutImg} src={Oferta1} alt='Oferta1' />
						</div>
						<button className={css.submitButtom} onClick={handleClick}>
							Umów się
						</button>
					</div>
				</li>
				{/*<li>
					<div className={css.aboutTitleWrapper}>
						<h2 className={css.aboutTitle}>Psychoterapia indywidualna</h2>
					</div>
					<div className={css.aboutContainer}>
						<p className={css.aboutTextRight}>
							Psychoterapia integracyjna to forma wsparcia dla dorosłych, którzy
							zmagają się z różnorodnymi problemami osobistymi. W jej trakcie
							pacjent przechodzi przez proces pozytywnych zmian – przekształca
							niekorzystne schematy myślenia, zdobywa nowe umiejętności oraz
							wypracowuje zdrowe reakcje na trudne sytuacje, co pomaga mu
							rozładować emocjonalne napięcia. Ten rodzaj terapii sprzyja
							osobistemu rozwojowi, zwiększa samoświadomość i ułatwia
							zrozumienie problemów w różnych sferach życia.
							<br />
							<br />
							Psychoterapia to skuteczna metoda leczenia zaburzeń emocjonalnych
							i psychicznych. W nurcie integracyjnym zakłada się, że trudności
							pacjentów mają różne źródła, dlatego nie istnieje jeden,
							uniwersalny sposób pracy z nimi. Psychoterapeuta integracyjny
							świadomie czerpie z dorobku różnych podejść terapeutycznych,
							dysponując szerokim zestawem metod i technik, które dostosowuje do
							potrzeb pacjenta oraz charakteru jego problemów. Fundamentem mojej
							pracy jest tworzenie relacji opartej na empatii i pełnej
							akceptacji, co pozwala pacjentowi czuć się bezpiecznie i
							rozumianym. Taka relacja sprzyja odpowiedniemu dopasowaniu metod
							terapeutycznych, które najlepiej odpowiadają indywidualnym
							potrzebom i zgłaszanym trudnościom pacjenta
						</p>
						<div className={css.textImgContainerReverse}>
							<p className={css.aboutTextRight}>
								Terapia integracyjna koncentruje się na identyfikacji tych
								aspektów życia, które niekorzystnie wpływają na emocje pacjenta.
								Kluczowe jest budowanie terapeutycznej więzi opartej na
								zrozumieniu, co pozwala pacjentowi wzmacniać poczucie własnej
								wartości i wprowadzać nowe sposoby reagowania na codzienne
								wyzwania. Dzięki lepszemu kontaktowi z własnymi emocjami i
								rozwijaniu samoświadomości, pacjent uczy się rozpoznawać swoje
								potrzeby oraz kształtować bardziej satysfakcjonujące relacje z
								otoczeniem. <br />
								<br />
								Psychoterapia integracyjna to nie tylko skuteczne narzędzie
								radzenia sobie z trudnościami, ale także ścieżka wspierająca
								rozwój osobisty i zdolności do lepszego rozumienia siebie i
								swojego życia.
							</p>
							<img className={css.aboutImg} src={Oferta2} alt='Oferta2' />
						</div>
						<button className={css.submitButtom} onClick={handleClick}>
							Umów się
						</button>
					</div>
				</li>*/}
				<li>
					<div className={css.aboutTitleWrapper}>
						<h2 className={css.aboutTitle}>Diagnostyka psychologiczna</h2>
					</div>
					<div className={css.aboutContainer}>
						<p className={css.aboutText}>
							Podczas konsultacji psychologicznych koncentruję się na analizie
							problemów, z jakimi zgłasza się klient, aby wspólnie znaleźć
							najlepsze rozwiązania. Konsultacje mogą obejmować różnorodne
							trudności, takie jak problemy wychowawcze, trudne relacje
							rodzinne, brak skutecznej komunikacji, a także wyzwania w
							relacjach między rodzicami a dziećmi.
							<br />
							<br />
							Poradnictwo psychologiczne ma na celu wspieranie klientów w
							korygowaniu błędnych przekonań, eliminacji nieskutecznych lub
							destrukcyjnych zachowań oraz wspomaganiu podejmowania właściwych
							decyzji. To proces, który pomaga odkryć nowe możliwości działania
							oraz skutecznie realizować podjęte decyzje.
						</p>
						<div className={css.textImgContainer}>
							<p className={css.aboutText}>
								W ramach poradnictwa oferuję również wsparcie dla rodziców.
								Chociaż każdy rodzic pragnie jak najlepiej wychować swoje
								dziecko, czasami napotyka na trudności wynikające z takich
								czynników, jak brak wsparcia, zmęczenie, rutyna, rezygnacja z
								własnych potrzeb czy brak umiejętności. Te czynniki mogą
								utrudniać budowanie relacji z dzieckiem, prowadząc do poczucia
								frustracji i niezadowolenia. <br />
								<br />
								Jeśli chcesz zrozumieć, które z Twoich działań przynoszą
								nieoczekiwane efekty lub co możesz zmienić, aby czerpać pełnię
								radości z rodzicielstwa, zapraszam na spotkanie konsultacyjne.
								Podczas naszych rozmów pomogę Ci zrozumieć istotę problemu i
								wskażę konkretne sposoby, które mogą pomóc w osiągnięciu
								większego spełnienia w roli rodzica oraz lepszego zrozumienia
								własnych potrzeb i oczekiwań.
							</p>
							<img className={css.aboutImg} src={Oferta3} alt='Oferta3' />
						</div>
						<button className={css.submitButtom} onClick={handleClick}>
							Umów się
						</button>
					</div>
				</li>
				<li>
					<div className={css.aboutTitleWrapper}>
						<h2 className={css.aboutTitle}>Diagnostyka psychologiczna</h2>
					</div>
					<div className={css.aboutContainer}>
						<p className={css.aboutTextRight}>
							Diagnoza psychologiczna jest procesem, w którym psycholog,
							wykorzystując odpowiednie narzędzia diagnostyczne, takie jak
							wywiady, obserwacje, testy i kwestionariusze, analizuje
							psychologiczne aspekty funkcjonowania osoby badanej. Celem tego
							procesu jest zrozumienie psychologicznych mechanizmów wpływających
							na pojawiające się trudności, co umożliwia przewidywanie zmian
							oraz określenie sposobów ich wprowadzania. Tego typu diagnoza
							stanowi również szansę na głębsze poznanie własnych predyspozycji
							i zasobów psychicznych.
							<br />
							<br />W moim gabinecie oferuję testy osobowościowe, które
							pozwalają na stworzenie szczegółowego profilu psychologicznego,
							określenie silnych i słabszych stron badanej osoby oraz
							zrozumienie jej osobowości w sposób całościowy.
						</p>
						<div className={css.textImgContainerReverse}>
							<p className={css.aboutTextRight}>
								Badanie intelektualne, w tym pomiar ilorazu inteligencji, służy
								określeniu poziomu inteligencji oraz ocenie funkcji poznawczych,
								takich jak pamięć, koncentracja uwagi, myślenie abstrakcyjne czy
								percepcja. <br />
								<br />
								Dla osób rozważających wybór ścieżki zawodowej, przeprowadzam
								testy preferencji zawodowych, które analizują zainteresowania,
								preferowane rodzaje działań i warunki pracy. Pomaga to wybrać
								kierunek edukacji, zawód lub podjąć decyzję o zmianie
								kwalifikacji. <br />
								<br />
								Na życzenie klienta mogę również przygotować pisemną opinię
								psychologiczną, opartą na dokładnej analizie i interpretacji
								wyników przeprowadzonych badań.
							</p>
							<img className={css.aboutImg} src={Oferta4} alt='Oferta4' />
						</div>
						<button className={css.submitButtom} onClick={handleClick}>
							Umów się
						</button>
					</div>
				</li>
			</ul>
		</section>
	)
}

export default OfertaFirst
